import { styled } from '@mui/material/styles';
import { Grid2, TextField } from '@mui/material';

export const StyledGrid = styled(Grid2)(({ theme }) => ({
  padding: theme.spacing(2),
}));

export const CustomTextField = styled(TextField)(({ theme, bgColor }) => ({
  height: '100%',
  width: '100%',
  '& .MuiOutlinedInput-root': {
    borderRadius: '8px', // Rounded corners
    color: '#fff',
    width: '100%',
    maxWidth: '100%',
    '& fieldset': {
      borderColor: 'var(--secondary-color)', // Default outline color
    },
    '&:hover fieldset': {
      borderColor: 'var(--secondary-color)', // Hover color
    },
    '&.Mui-focused fieldset': {
      borderColor: 'var(--primary-color)', // Focused color
    },
    '&.Mui-error fieldset': {
      borderColor: 'var(--error-color)',
    },
    '&.Mui-disabled': {
      color: 'var(--disabled-color)',
      '& fieldset': {
        borderColor: 'rgba(255,255,255,0.22)',
      },
    },
  },
  '& .MuiInputLabel-root': {
    color: 'var(--secondary-color)', // Label color
    '&[data-shrink="false"]': {
      fontSize: '0.8rem',
    },
    '&.Mui-error': {
      color: 'var(--error-color)',
    },
    '&.Mui-disabled': {
      color: 'rgba(255,255,255,0.38)',
    },
  },
  '& .MuiInputLabel-root.Mui-focused': {
    color: 'var(--primary-color)', // Focused label color,
    '&.Mui-error': {
      color: 'var(--error-color)',
    },
  },
  '& .MuiInputBase-input': {
    color: '#fff',
    fontSize: '0.8rem',
    [theme.breakpoints.down('sm')]: {
      fontSize: '16px',
    },
    minWidth: 0,
  },
  '& .MuiOutlinedInput-root.Mui-disabled .MuiInputBase-input': {
    WebkitTextFillColor: 'var(--disabled-color)',
    color: 'var(--disabled-color)',
  },
  '& .MuiOutlinedInput-root.Mui-disabled input:-webkit-autofill': {
    WebkitTextFillColor: 'var(--disabled-color) !important',
    caretColor: 'var(--disabled-color)',
  },
  '& .MuiOutlinedInput-root.Mui-disabled input:-webkit-autofill:hover, & .MuiOutlinedInput-root.Mui-disabled input:-webkit-autofill:focus':
    {
      WebkitTextFillColor: 'var(--disabled-color) !important',
    },
  '& p.Mui-error': {
    color: 'var(--error-color)',
  },
}));
